var map = {
	"./FiraSans-Bold.ttf": 534,
	"./FiraSans-Medium.ttf": 535,
	"./FiraSans-Regular.ttf": 536,
	"./FiraSans-SemiBold.ttf": 537,
	"./KumbhSans-Bold.ttf": 538,
	"./KumbhSans-Light.ttf": 539,
	"./KumbhSans-Regular.ttf": 540,
	"./NotoEmoji.ttf": 541,
	"./NotoSerif-Regular.ttf": 542,
	"./Quicksand-Bold.ttf": 543,
	"./Quicksand-Light.ttf": 544,
	"./Quicksand-Medium.ttf": 545,
	"./Quicksand-Regular.ttf": 546,
	"./Quicksand-SemiBold.ttf": 547,
	"./Roboto-Black.ttf": 548,
	"./Roboto-BlackItalic.ttf": 549,
	"./Roboto-Bold.ttf": 550,
	"./Roboto-BoldItalic.ttf": 551,
	"./Roboto-Italic.ttf": 552,
	"./Roboto-Light.ttf": 553,
	"./Roboto-LightItalic.ttf": 554,
	"./Roboto-Medium.ttf": 555,
	"./Roboto-MediumItalic.ttf": 556,
	"./Roboto-Regular.ttf": 557,
	"./Roboto-Thin.ttf": 558,
	"./Roboto-ThinItalic.ttf": 559,
	"./SeptemberMornings.ttf": 560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 533;